import { Component, OnInit } from '@angular/core';
import { TABS } from 'src/app/dummy/tab';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { Location } from '@angular/common';
import { SKILL_OBJECT, STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { IActivity, IModule } from 'src/app/interfaces/resource';
import { ConvertService, removeObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { Observable } from 'rxjs';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { AddSpeakerComponent } from './add-speaker/add-speaker.component';
import { AddConversationComponent } from './add-conversation/add-conversation.component';

@Component({
  selector: 'app-conversation',
  templateUrl: './conversation.component.html',
  styleUrls: ['./conversation.component.scss']
})
export class ConversationComponent implements OnInit {
  tabs = TABS.CONVERSATION;
  TITLE = "Modules"
  ITEM: IActivity;
  ITEM_KEY: any;
  MODULE_KEY: any;
  MODULE: IModule;
  pictureDownloadURL: any;
  soundDownloadURL: any;

  form: FormGroup;
  name: AbstractControl;
  vocabulary: AbstractControl;
  keyword: AbstractControl;
  instruction: AbstractControl;
  defaultInstruction: AbstractControl;
  youtubeId: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  SKILL = 'speaking';
  SKILL_NAME = 'Speaking';
  ACTIVITY_TYPE = 'conversation'
  START_UPLOAD: boolean = false;
  uploadPercentPicture: Observable<number>;
  SELECTED_PICTURE_FILE: any;
  ACTIVITIES_LIST = [];
  ACTIVITY_TYPE_LIST: any[];
  ACTIVITY_TYPE_OBJECT: any = {};

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: ActivityStore
    , private location: Location
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
    , private storage: FireStorageService
  ) { }

  goBack() {
    this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  }

  // goBackToActivityType() {
  //   this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  // }


  // newActivity() {
  //   this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/draft`])
  // }

  uploadFilePicture(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_PICTURE_FILE = event;
    }
  }


  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required],
      instruction: [null],
      defaultInstruction: [true],
      youtubeId: [null],
      languageNotes: [null],
      reading: [null, Validators.required]
    })
    await this.auth.fetchUser();
    this.route.params.subscribe(async params => {
      const { id, MODULE_KEY } = params;
      this.ITEM_KEY = id === 'draft' ? null : id;
      this.MODULE_KEY = MODULE_KEY
      this.tabs = TABS.CONVERSATION.filter(m => m.key === this.SKILL).map(m => ({ path: `${m.path}/${MODULE_KEY}/${m.key === SKILL_OBJECT.SPEAKING.key ? id : 'draft'}`, label: m.label, key: m.key }))
      this.ACTIVITY_TYPE_LIST = await this.store.fetchActivityType()
      this.ACTIVITY_TYPE_OBJECT = this.ACTIVITY_TYPE_LIST.filter(m => m.key === this.ACTIVITY_TYPE)[0];
      this.MODULE = await this.store.fetchModule(this.MODULE_KEY)
      if (!this.MODULE) {
        this.router.navigate(['/404']);
        return;
      }
      if (id !== 'draft') {
        this.store.fetchActivity(id, doc => {
          this.ITEM = doc;
          if (!doc) {
            this.goBack()
            return;
          }
          const { name, instruction, defaultInstruction, languageNotes, youtubeId, reading } = doc;
          this.form.patchValue({ name, instruction, defaultInstruction, languageNotes, youtubeId, reading })
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.form.patchValue({ name: null, instruction: null, defaultInstruction: true, languageNotes: null, youtubeId: null, reading: null })
      }
    })
  }

  ngOnDestroy(): void {
    const { fetchActivityRef } = this.store;
    fetchActivityRef && fetchActivityRef.unsubscribe();
    const { fetchActivityByModuleRef } = this.resource;
    fetchActivityByModuleRef && fetchActivityByModuleRef.unsubscribe();
  }


  async onSave(f: any, isBack: boolean) {
    if (!this.SELECTED_PICTURE_FILE && !this.ITEM) {
      alert('Please select picture file');
      return;
    }
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      //PICTURE
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      if (this.SELECTED_PICTURE_FILE) {
        this.START_UPLOAD = true;

        const picturePath = `${this.MODULE_KEY}/${this.ACTIVITY_TYPE}/${key}`;
        const pictureTask = this.storage.uploadFile(this.SELECTED_PICTURE_FILE, picturePath);
        this.uploadPercentPicture = pictureTask.percentageChanges();
        const downloadURLPicture = (await pictureTask).ref.getDownloadURL();
        downloadURLPicture.then(pictureUrl => {
          const { name, instruction, defaultInstruction, youtubeId, languageNotes, reading } = f;
          const { user, selectedCompanyKey } = this.auth;
          const registerStatus = STATUS_OBJECT.submitted;
          const activity: IActivity = {
            key: key,
            status: DISPLAY_STATUS_OBJECT.ACTIVE,
            isDelete: false,
            created_at: this.ITEM ? this.ITEM.created_at : new Date(),
            created_by: this.ITEM ? this.ITEM.created_by : user.uid,
            updated_at: new Date(),
            updated_by: user.uid,
            date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
            page_key: ConvertService.pageKey(),
            keyword: null,
            organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
            organizationKey: selectedCompanyKey,
            created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
            updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
            register_status: registerStatus,
            //fields
            name: name || null,
            reading: reading || null,
            instruction: instruction || null,
            defaultInstruction: defaultInstruction || false,
            pictureDownloadURL: pictureUrl,
            youtubeId: youtubeId,
            languageNotes: languageNotes,
            conversations: this.ITEM ? this.ITEM.conversations : [],
            speakers: this.ITEM ? this.ITEM.speakers : [],
            hasSubActivity: false,
            //module ref
            skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
            skillRef: this.ds.skillRef().doc(this.SKILL).ref,
            skillName: this.SKILL_NAME,
            activityTypeKey: this.ACTIVITY_TYPE,
            activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
            activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
            moduleKey: this.MODULE_KEY,
            moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
          }
          this.store.addItem(activity, this.MODULE, this.ITEM ? true : false, (success, res) => {
            if (success) {
              this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
              this.processClose = false;
              this.processNew = false;
              this.START_UPLOAD = false;
              if (isBack) {
                this.location.back()
              }
              else {
                this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/${activity.key}`])
              }
              this.form.enable();
            }
          })
        }).catch(error => {
          this.START_UPLOAD = false;
          alert(error)
        })
      } else {
        const { name, instruction, defaultInstruction, youtubeId, languageNotes, reading } = f;
        const { user, selectedCompanyKey } = this.auth;
        const registerStatus = STATUS_OBJECT.submitted;
        const activity: IActivity = {
          key: key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          name: name || null,
          reading: reading || null,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          pictureDownloadURL: this.ITEM ? this.ITEM.pictureDownloadURL : null,
          youtubeId: youtubeId,
          languageNotes: languageNotes,
          conversations: this.ITEM ? this.ITEM.conversations : [],
          speakers: this.ITEM ? this.ITEM.speakers : [],
          hasSubActivity: false,
          //module ref
          skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
          skillName: this.SKILL_NAME,
          skillRef: this.ds.skillRef().doc(this.SKILL).ref,
          activityTypeKey: this.ACTIVITY_TYPE,
          activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.MODULE_KEY,
          moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
        }
        this.store.addItem(activity, this.MODULE, this.ITEM ? true : false, (success, res) => {
          if (success) {
            this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
            this.processClose = false;
            this.processNew = false;
            this.START_UPLOAD = false;
            if (isBack) {
              this.location.back()
            }
            else {
              this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/${activity.key}`])
            }
            this.form.enable();
          }
        })
      }

    }
  }

  onClone() {
    if (!this.ITEM) return;
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'OK', name: "Are you sure you want to clone this activity?", title: 'Close Activity' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { uid, selectedCompanyKey } = this.auth;
        const { name, difficultyData, organizationKey, register_status, description, difficultyKey, lessonKey } = this.MODULE;
        const ACTIVITY_TYPE_OBJECT = this.ACTIVITY_TYPE_LIST.find(m => m.key === 'introduction_dialogue');
        const skill = { key: 'listening', name: 'Listening' }
        const moduleData: IModule = {
          key: this.ds.createId(),
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : this.ds.serverTimestamp(),
          created_by: this.ITEM ? this.ITEM.created_by : uid,
          updated_at: this.ds.serverTimestamp(),
          updated_by: uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: this.ITEM ? this.ITEM.page_key : ConvertService.pageKey(),
          keyword: [ConvertService.toCapitalize(`${name.trim()}`), difficultyData.key, ACTIVITY_TYPE_OBJECT.key],
          organizationRef: this.ds.companyRef().doc(organizationKey).ref,
          organizationKey: organizationKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(uid).ref,
          register_status: register_status,
          //fields
          name: name.trim(),
          description,
          activityTypeKey: ACTIVITY_TYPE_OBJECT.key,
          activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE_OBJECT.key).ref,
          difficultyKey: difficultyKey,
          difficultyRef: this.ds.difficultyRef().doc(difficultyKey).ref,
          //skill
          skillData: skill,
          activityTypeData: ACTIVITY_TYPE_OBJECT,
          difficultyData: difficultyData,
          skillRef: [{ key: skill.key, ref: this.ds.skillRef().doc(skill.key).ref }],
          skillKey: [skill.key],
          default_skill: skill.key,
          lessonKey: lessonKey,
          lessonRef: this.ds.lessonColRef().doc(lessonKey).ref,
        }
        const activityData: IActivity = {
          key: this.ds.createId(),
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: new Date(),
          created_by: uid,
          updated_at: new Date(),
          updated_by: uid,
          date_key: ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ds.userProfileRef().doc(uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(uid).ref,
          register_status: STATUS_OBJECT.submitted,
          //fields
          name: this.ITEM.name || null,
          reading: this.ITEM.reading || null,
          instruction: this.ITEM.instruction || null,
          defaultInstruction: this.ITEM.defaultInstruction || false,
          pictureDownloadURL: this.ITEM ? this.ITEM.pictureDownloadURL : null,
          youtubeId: this.ITEM.youtubeId || null,
          languageNotes: this.ITEM.languageNotes || null,
          conversations: this.ITEM ? this.ITEM.conversations : [],
          speakers: this.ITEM ? this.ITEM.speakers : [],
          hasSubActivity: false,
          //module ref
          skillKey: moduleData.skillData.key,
          skillName: moduleData.skillData.name,
          skillRef: this.ds.skillRef().doc(moduleData.skillData.key).ref,
          activityTypeKey: ACTIVITY_TYPE_OBJECT.key,
          activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE_OBJECT.key).ref,
          activityTypeName: ACTIVITY_TYPE_OBJECT.name,
          moduleKey: moduleData.key,
          moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(moduleData.key).ref,
        }
        this.store.cloneActivity(activityData, moduleData, (success, res) => {
          this.snackBar.open("Activity has been cloned successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }


  edit(question) {
    let dialogRef = this.dialog.open(AddSpeakerComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        ANSWER: question,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  deleteSpeaker(speaker) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: speaker.name, title: 'Delete Speaker' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { name, instruction, defaultInstruction, youtubeId, languageNotes, reading } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const registerStatus = STATUS_OBJECT.submitted;
        const { speakers } = this.ITEM
        const ANSWER_DATA = removeObjArray(speakers, speaker.key)
        const activity: IActivity = {
          key: this.ITEM.key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          name: name || null,
          reading: reading || null,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          pictureDownloadURL: this.ITEM ? this.ITEM.pictureDownloadURL : null,
          youtubeId: youtubeId,
          languageNotes: languageNotes,
          conversations: this.ITEM ? this.ITEM.conversations : [],
          speakers: ANSWER_DATA,
          hasSubActivity: false,
          //modules
          skillKey: this.ITEM.skillKey,
          skillRef: this.ITEM.skillRef,
          skillName: this.SKILL_NAME,
          activityTypeKey: this.ITEM.activityTypeKey,
          activityTypeRef: this.ITEM.activityTypeRef,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.ITEM.moduleKey,
          moduleRef: this.ITEM.moduleRef,
        }
        this.store.update(activity, (success, res) => {
          this.snackBar.open("Speaker has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }

  delete(conversation) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: conversation.script, title: 'Delete Conversation' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { name, instruction, defaultInstruction, youtubeId, languageNotes, reading } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const registerStatus = STATUS_OBJECT.submitted;
        const { conversations } = this.ITEM
        const ANSWER_DATA = removeObjArray(conversations, conversation.key)
        const activity: IActivity = {
          key: this.ITEM.key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          name: name || null,
          reading: reading || null,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          pictureDownloadURL: this.ITEM ? this.ITEM.pictureDownloadURL : null,
          youtubeId: youtubeId,
          languageNotes: languageNotes,
          conversations: ANSWER_DATA,
          speakers: this.ITEM ? this.ITEM.speakers : [],
          hasSubActivity: false,
          //modules
          skillKey: this.ITEM.skillKey,
          skillRef: this.ITEM.skillRef,
          skillName: this.SKILL_NAME,
          activityTypeKey: this.ITEM.activityTypeKey,
          activityTypeRef: this.ITEM.activityTypeRef,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.ITEM.moduleKey,
          moduleRef: this.ITEM.moduleRef,
        }
        this.store.update(activity, (success, res) => {
          this.snackBar.open("Conversation has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }


  addNewLine(SPEAKER) {
    let dialogRef = this.dialog.open(AddSpeakerComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        SPEAKER: SPEAKER || null,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  addNewConversation(conversation) {
    let dialogRef = this.dialog.open(AddConversationComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        CONVERSATION: conversation || null,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}
